<template>
  <div>
    <profileCard
      :imageUrl="companyLogo"
      :name="companyName"
      :email="companyEmail"
      :phone="companyPhone"
    >
      <tablink linkName="Profile Info" routePath="/profile/profile-info" />
      <tablink
        linkName="Language Settings"
        routePath="/profile/languageSettings"
      />
      <tablink
        linkName="Currency Settings"
        routePath="/profile/currencySettings"
      />
      <tablink linkName="Device Binding" routePath="/profile/deviceBinding" />
      <tablink linkName="Payment Config" routePath="/profile/paymentConfig" />
      <tablink
        linkName="Login Security Settings"
        routePath="/profile/loginSecurity"
      />
      <tablink linkName="B2B Provider" routePath="/profile/b2bProvider" />
      <tablink
        linkName="Notification"
        routePath="/profile/notificationSettings"
      />
      <tablink
        linkName="Extended Attributes"
        routePath="/profile/extendedAttributes"
      />
      <tablink
        linkName="Delivery Partners"
        routePath="/profile/deliveryPartners"
      />
      <tablink linkName="KYC Preferences" routePath="/profile/kycPreferences" />
      <tablink linkName="Webhook Integration" routePath="/profile/webhook" />
      <tablink
        linkName="Build Generation"
        routePath="/profile/buildGeneration"
      />
    </profileCard>
  </div>
</template>
<script>
import currentUserData from "@/mixins/currentUser";
import profileCard from "@/components/Generics/profileCard.vue";
import tablink from "@/components/Common/tablink";
export default {
  mixins: [currentUserData],
  components: {
    profileCard,
    tablink,
  },
  data() {
    return {
      companyName: "",
      companyLogo: "",
      companyPhone: "",
      companyEmail: "",
    };
  },
  async mounted() {
    const tenantProfileData = await this.$store.dispatch(
      "tenant/getTenantDetailByID",
      this.$currentUserData._id
    );
    this.companyName = tenantProfileData?.response?.company?.name || "";
    this.companyLogo = tenantProfileData?.response?.company?.logo || "";
    this.companyPhone =
      tenantProfileData?.response?.authentication?.phone || "";
    this.companyEmail =
      tenantProfileData?.response?.authentication?.email || "";
    this.tenantId = tenantProfileData?.response?._id || "";
  },
};
</script>
